import React from 'react'
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';
import Div from '../Div';

export default function Team({ memberImage, memberName, memberDesignation, memberSocial, memberEmail, memberNumber }) {

  // styles object
  // const styles = {
  //   card: {
  //     // width: '260px',
  //     borderRadius: '8px',
  //     overflow: 'hidden',
  //     boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
  //     textAlign: 'center',
  //     backgroundColor: '#fff',
  //     margin: '20px auto',
  //   },
  //   imageWrapper: {
  //     width: '100%',
  //     // height: '280px',
  //     overflow: 'hidden',
  //   },
  //   image: {
  //     width: '100%',
  //     height: '100%',
  //     objectFit: 'cover',
  //   },
  //   infoBox: {
  //     backgroundColor: '#ff4a17',
  //     padding: '20px',
  //     color: '#fff',
  //   },
  //   designation: {
  //     fontSize: '1.2rem',
  //     fontWeight: '400',
  //     marginBottom: '4px',
  //   },
  //   name: {
  //     fontSize: '1.4rem',
  //     marginBottom: '10px',
  //     fontWeight: '600',
  //   },
  //   description: {
  //     fontSize: '13px',
  //     lineHeight: '1.5',
  //     color: '#eaf7fa',
  //   },
  //   social: {
  //     display: 'flex',
  //     justifyContent: 'center',
  //     gap: '12px',
  //     marginTop: '10px',
  //   },
  //   socialIcon: {
  //     fontSize: '18px',
  //     color: '#fff',
  //     transition: '0.3s',
  //   },
  //   memberLinks: {
  //     color: '#fff',
  //     transition: '0.3s',
  //   }
  // };

  const styles = {
    card: {
      borderRadius: '8px',
      overflow: 'hidden',
      boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
      textAlign: 'center',
      backgroundColor: '#fff',
      margin: '20px auto',
      display: 'flex',
      flexDirection: 'column',
      height: '100%', // ✅ makes it stretch equally inside a grid
      minHeight: '460px', // ✅ ensures same minimum height
      maxHeight: '530px', // ✅ ensures same minimum height
    },
    imageWrapper: {
      width: '100%',
      height: '420px', // ✅ fixed image height
      overflow: 'hidden',
    },
    image: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    infoBox: {
      backgroundColor: '#ff4a17',
      padding: '20px',
      color: '#fff',
      flexGrow: 1, // ✅ fills remaining space equally
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      maxHeight: '160px', // More compact info box
    },
    designation: {
      fontSize: '1.2rem',
      fontWeight: '400',
      marginBottom: '4px',
    },
    name: {
      fontSize: '1.4rem',
      marginBottom: '10px',
      fontWeight: '600',
    },
    description: {
      fontSize: '13px',
      lineHeight: '1.5',
      color: '#eaf7fa',
    },
    social: {
      display: 'flex',
      justifyContent: 'center',
      gap: '12px',
      marginTop: '10px',
    },
    socialIcon: {
      fontSize: '18px',
      color: '#fff',
      transition: '0.3s',
    },
    memberLinks: {
      color: '#fff',
      transition: '0.3s',
      marginTop: '4px',
      wordBreak: 'break-word', // ✅ prevents email/number overflow
    },
  };

  return (
    <Div style={styles.card}>
      <Div style={styles.imageWrapper}>
        <img src={memberImage} alt={memberName} style={styles.image} />
      </Div>

      <Div style={styles.infoBox}>
        <div style={styles.name}>{memberName}</div>
        <div style={styles.designation}>{memberDesignation}</div>

        {memberEmail && (
          <Link to={`mailto:${memberEmail}`}>
            <div style={styles.memberLinks}>{memberEmail}</div>
          </Link>
        )}

        {memberNumber && (
          <Link to={`tel:${memberNumber}`}>
            <div style={styles.memberLinks}>{memberNumber}</div>
          </Link>
        )}

        {/* <Div style={styles.social}>
          {memberSocial.linkedin && (
            <Link to={memberSocial.linkedin}>
              <Icon icon="fa6-brands:linkedin-in" style={styles.socialIcon} />
            </Link>
          )}
          {memberSocial.twitter && (
            <Link to={memberSocial.twitter}>
              <Icon icon="fa-brands:twitter" style={styles.socialIcon} />
            </Link>
          )}
          {memberSocial.youtube && (
            <Link to={memberSocial.youtube}>
              <Icon icon="fa-brands:youtube" style={styles.socialIcon} />
            </Link>
          )}
          {memberSocial.email && (
            <Link to={memberSocial.facebook}>
              <Icon icon="fa-brands:facebook-f" style={styles.socialIcon} />
            </Link>
          )}
        </Div> */}
      </Div>
    </Div>
  )
}